import { render, staticRenderFns } from "./CaptureModal.vue?vue&type=template&id=364a6fee&scoped=true&lang=pug"
import script from "./CaptureModal.vue?vue&type=script&lang=js"
export * from "./CaptureModal.vue?vue&type=script&lang=js"
import style0 from "./CaptureModal.vue?vue&type=style&index=0&id=364a6fee&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a6fee",
  null
  
)

export default component.exports